import React, { useState } from "react";
import AuthService from "../../../api/AuthService";
import { useNavigate } from "react-router-dom";
import LoaderHelper from "../../../utils/Loader/LoaderHelper";
import { useAlert } from "../../../context/AlertContext";
import OrganizeProfilePage from "../../../entities/Settings/OrganizeProfile";
import BrandingPage from "../../../entities/Settings/Branding";

const Branding = () => {
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleAddNewCustomer = async (data) => {
    LoaderHelper.loaderStatus(true);
    setLoading(true)
    try {
      const result = await AuthService.handleCustomer(data);
      if (result?.success === true) {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "success");
        navigate("/dashboard/customer", { state: { refresh: true } });
      } else {
        setLoading(false)
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false)
      LoaderHelper.loaderStatus(false);
      showAlert(error, "error");
    }
  };
  return (
    <BrandingPage handleAddNewCustomer={handleAddNewCustomer} loading={loading} />
  )

}

export default Branding;
